export default __webpack_public_path__ + "static/media/error.2b91083a.gif";